import clsx from "clsx";
import React, { FC, PropsWithChildren, ReactNode } from "react";

import { Authenticator } from "../../auth";
import { LabelsContext, LabelsContextData } from "../../contexts/labels";
import { PageNodesContext, PageNodesContextData } from "../../contexts/page-nodes";
import { LocaleContext, LocaleContextData } from "../../i18n/locale-context";
import "../../styles/global.css";

export type GlobalLayoutProps = PageNodesContextData &
  LocaleContextData &
  LabelsContextData & {
    className?: string;
    outerChildren?: ReactNode;
  };

export const GlobalLayout: FC<PropsWithChildren<GlobalLayoutProps>> = ({
  children,
  outerChildren,
  className,
  labels,
  locale,
  localizedUrls,
  pageNodes = [],
  currentPage,
  richTextLabels,
}) => {
  return (
    <PageNodesContext.Provider value={{ pageNodes, localizedUrls, currentPage }}>
      <LocaleContext.Provider value={{ locale }}>
        <LabelsContext.Provider value={{ labels, richTextLabels }}>
          <Authenticator>
            {outerChildren}
            <div className={clsx("relative flex flex-col min-h-screen", className)}>{children}</div>
          </Authenticator>
        </LabelsContext.Provider>
      </LocaleContext.Provider>
    </PageNodesContext.Provider>
  );
};
